__turbopack_context__.v({
  "fadeInUp": "NxtrBa_fadeInUp",
  "heroDescription": "NxtrBa_heroDescription",
  "heroTitle": "NxtrBa_heroTitle",
  "heroTitleGradient": "NxtrBa_heroTitleGradient",
});
